import { initialState } from '../reducers/passports';
import { peek, selector } from '../selectorHelpers';

export const selectPassports = (state) => state.get('passports', initialState);

export const passportsSelectItems = selector(
  selectPassports,
  peek('passports'),
);
export const passportsSelectLoading = selector(
  selectPassports,
  peek('isLoading'),
);
